import React from 'react'
import styled from 'styled-components'

type ServiceContractsIconProps = {
  hasActiveContract?: boolean
  hasExpiredContract?: boolean
  className?: string
  size?: string
}

const ServiceContractsIcon = ({ hasActiveContract = false, hasExpiredContract = false, size = '18px', className = '' }: ServiceContractsIconProps) => {
  const activeIcon = hasActiveContract ? '/img/service_contract_active.svg' : '/img/service_contract_none.svg'
  const expiredIcon = hasExpiredContract ? '/img/service_contract_expired.svg' : '/img/service_contract_none.svg'
  const noneIcon = '/img/service_contract_none.svg'

  const ContractIcon = () => {
    return hasActiveContract
      ? <S.ServiceContractIcon aria-label="active_service_contract" src={activeIcon} $size={size} {...{ className }} />
      : hasExpiredContract
        ? <S.ServiceContractIcon aria-label="expired_service_contract" src={expiredIcon} $size={size} {...{ className }} />
        : <S.ServiceContractIcon aria-label="no_service_contract" src={noneIcon} $size={size} {...{ className }} />
  }

  return (
    <ContractIcon />
  )
}

export default ServiceContractsIcon

const S = {
  ServiceContractIcon: styled.img.withConfig({
    shouldForwardProp: (prop) => !['$size'].includes(prop)
  })<{ $size: string }>`
    cursor: pointer;
    max-width: 24px;
    align-self: flex-start;
    width: ${({ $size }) => $size};
    height: ${({ $size }) => $size};
  `
}
